import { useTranslations } from "next-intl"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    supplyPoint: graphql(`
        fragment useFormatSupplyPointMeterPointId_SupplyPoint on SupplyPointType {
            marketName
            meterPoint {
                id
            }
        }
    `),
}

export function useFormatSupplyPointMeterPointId() {
    const t = useTranslations("useFormatSupplyPointMeterPointId")

    return (supplyPointFragment: FragmentOf<typeof graphQLFragments.supplyPoint> | null) => {
        const supplyPoint = readFragment(graphQLFragments.supplyPoint, supplyPointFragment)

        if (!supplyPoint) {
            return t("fallback")
        }

        const { marketName, meterPoint } = supplyPoint

        return t(`meterPointId`, {
            marketName,
            id: meterPoint?.id,
        })
    }
}

useFormatSupplyPointMeterPointId.messages = ["useFormatSupplyPointMeterPointId"] as const

useFormatSupplyPointMeterPointId.fragments = graphQLFragments
